import React from "react";
import {uid} from "react-uid";
import InvalidFeedback from "../../../common/invalid_feedback";
import StartDateDropdown from "./start_date_dropdown";
import EndDateDropdown from "./end_date_dropdown";

function ExperienceForm(props) {
  const { career, onExperienceChange, handleRemoveExperience } = props;
  const experiences = career.experiences_attributes;

  return experiences.map((experience, index) => {
    return experience._destroy === false && (
      <div className='mb-4 experience-unit' key={uid(experience, index)}>
        <div className='form-group row'>
          <label className='col-12 col-md-3 col-form-label required' htmlFor={`career-experiences-attributes-${index}-title`}>
            役職
          </label>
          <div className='col-12 col-md-9'>
            <input
              name='title'
              className={`${experience.errors.title ? "form-control is-invalid" : "form-control"}`}
              onChange={event => onExperienceChange(event, experience, null)}
              value={experience.title || ""}
              placeholder='CEO'
              required='required'
              type='text'
              id={`career-experiences-attributes-${index}-title`}
            />
            <InvalidFeedback errors={experience.errors.title} label='役職' />
          </div>
        </div>
        <div className='form-group row mb-0'>
          <label className='col-12 col-md-3 col-form-label required' htmlFor={`career-experiences-attributes-${index}-start-year`}>
            在籍期間
          </label>
          <div className='col-12 col-md-9 form-group row no-gutters'>
            <StartDateDropdown
              index={index}
              experience={experience}
              initialStartDate={experience.start_date || ""}
              onExperienceChange={onExperienceChange}
              key={"start_date_" + uid(experience, index)}
            />
            {!experience.current && (
              <EndDateDropdown
                index={index}
                experience={experience}
                initialEndDate={experience.end_date || ""}
                onExperienceChange={onExperienceChange}
                key={"end_date_" + uid(experience, index)}
              />
            )}
          </div>
        </div>
        <div className='form-group row career-description'>
          <label className='col-12 col-md-3 col-form-label' htmlFor={`career-experiences-attributes-${index}-description`}>
            業務内容
          </label>
          <div className='col-12 col-md-9'>
            <textarea
              name='description'
              className={`${experience.errors.description ? "form-control is-invalid" : "form-control"}`}
              onChange={event => onExperienceChange(event, experience, null)}
              value={experience.description || ""}
              rows='5'
              id={`career-experiences-attributes-${index}-description`}
            />
            <InvalidFeedback errors={experience.errors.description} label='業務内容' />
          </div>
        </div>
        {index > 0 && (
          <div className='form-group row'>
            <div className='col-12'>
              <button type='button' className='btn-profile-edit' onClick={() => handleRemoveExperience(experience)}>
                <span>
                  <i className='fas fa-trash pr-1' />
                  この役職を削除
                </span>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  });
}

export default ExperienceForm;
